import React, { useState } from 'react'
import { Button, CircularProgress } from '@mui/material'
import { useNotify, useListContext, useGetIdentity } from 'react-admin'
import { joinStringArraysInObject } from 'src/helper/joinStringArraysInObject'
import { useTranslate } from 'react-admin'
import { businessUnitServices } from 'src/services/reservation/businessUnit/businessUnit.service'
import { installmentServices } from 'src/services/payment/installment/installment.service'
import { Download } from '@mui/icons-material'

export const InstallmentExportButton = () => {
  const { filterValues } = useListContext()
  const notify = useNotify()
  const translate = useTranslate()
  const { identity } = useGetIdentity()
  const [loading, setLoading] = useState(false)
  const [exportLoading, setExportLoading] = useState(false)

  const handleExport = async () => {
    setLoading(true)
    try {
      const updatedFilters = joinStringArraysInObject(filterValues)
      const exportStatus = await installmentServices.export(updatedFilters)
      if (exportStatus === 200) {
        notify('ra.message.export_success', { type: 'success', messageArgs: { email: identity?.email } })
      } else {
        notify('ra.message.export_error', { type: 'error' })
      }
    } catch (error) {
      notify('ra.message.export_error', { type: 'error' })
    } finally {
      setLoading(false)
      setExportLoading(true)
      setTimeout(()=>{setExportLoading(false)}, 10000)
    }
  }

  return (
    <Button
      onClick={handleExport}
      disabled={loading || exportLoading}
      startIcon={loading ? <CircularProgress size={20} /> : <Download fontSize='small' />}
      size='small'
      sx={{ margin: null, lineHeight: '1.5'}}
    >
      {translate('ra.action.export')}
    </Button>
  )
}
